import { useTranslation } from "react-i18next";
import styled from "styled-components";

const InputContainer = styled.div(({ isMobile }) => ({
  flex: 1,
  marginLeft: !isMobile && "0.5em",
  marginRight: !isMobile && "0.5em",
  position: "relative",
}));

const Error = styled.div(({ theme }) => ({
  fontSize: 12,
  color: theme.color.error,
  marginTop: "0.5em",
}));

const StyledDiv = styled.div(({ error, theme, height, isActive, transparentBorder, disabled }) => ({
  backgroundColor: disabled ? theme.color.gray : theme.color.white,
  height: height ? height : "3em",
  border: transparentBorder
    ? "none"
    : `1px solid ${
        !!error === true ? theme.color.error : isActive ? theme.color.text : theme.color.stroke
      }`,
  borderRadius: 6,
  fontSize: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingInlineEnd: "1em",
  paddingInlineStart: "1em",
  lineHeight: 1,
}));

const StyleEndImg = styled.img(({ ...props }) => ({
  marginInlineStart: "auto",
  width: 20,
  height: 20,
  alignSelf: "self-start",
}));

const StyleStartImg = styled.img(({ isMobile }) => ({
  width: isMobile ? 20 : 22,
  height: isMobile ? 20 : 22,
  marginInlineEnd: "1em",
}));

const StyledInput = styled.textarea(({ theme, disabled, height }) => ({
  fontFamily: "NotoSansHebrew",
  fontSize: 14,
  fontWeight: "300",
  resize: "none",
  width: "100%",
  height: height || "100%",
  backgroundColor: "transparent",
  pointerEvents: disabled ? "none" : "unset",

  border: 0,
  "::placeholder": {
    color: "#BDBFCE",
    fontSize: 16,
    paddingTop: 5,
  },
  lineHeight: 1,
  "&:focus": {
    outline: "none",
  },
  textAlign: "start",
}));

// const Label = styled.div(({ theme }) => ({
//   color: theme.color.text,
//   textAlign: "start",
//   fontWeight: 400,
//   marginBottm: 10,o
// }));

const Label = styled("div")`
  font-weight: "400";
  height: 21px;
  font-size: ${(p) => (p.shrink ? "13px !important" : "16px")};
  padding: ${(p) => (p.shrink ? "0px 6px" : "unset")};
  display: ${(p) => (p.shrink ? "block" : "none")};
  transform-origin: ${(p) => (p.shrink ? "top left" : "unset")};
  white-space: ${(p) => (p.shrink ? "nowrap" : "unset")};
  overflow: ${(p) => (p.shrink ? "hidden" : "unset")};
  text-overflow: ${(p) => (p.shrink ? "ellipsis" : "unset")};
  position: ${(p) => (p.shrink ? "absolute" : "unset")};
  right: ${(p) => (p.shrink && p.isRtl ? "12px" : "unset")};
  left: ${(p) => (p.shrink && !p.isRtl ? "12px" : "unset")};
  top: ${(p) => (p.shrink ? "-17px" : "unset")};
  background-color: ${(p) => (p.shrink ? "#ffffff" : "unset")};
  z-index: ${(p) => (p.shrink ? "999" : "unset")};
  color: ${(p) => (p.shrink ? "#8C89AC" : "unset")};
`;

const TextArea = ({
  label,
  placeholder,
  endImg,
  startImg,
  helperText,
  onEndImgClick,
  isActive,
  transparentBorder,
  disabled = false,
  height,
  isMobile,
  shrink = false,
  ...props
}) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  return (
    <InputContainer style={{ ...props.style }} isMobile={isMobile}>
      {!!label && (
        <Label isRtl={isRtl} shrink={shrink.toString()}>
          {label}
        </Label>
      )}
      <StyledDiv
        error={!!helperText}
        height={height}
        transparentBorder={transparentBorder}
        isActive={isActive}
        disabled={disabled}
      >
        {!!startImg && <StyleStartImg src={startImg} alt="input-start-img" isMobile={isMobile} />}
        <StyledInput
          dir={i18n.dir()}
          placeholder={placeholder || label}
          {...props}
          height={height}
          style={{ ...props.style, marginBottom: 0 }}
        />
        {!!endImg && <StyleEndImg src={endImg} alt="input-end-img" />}
      </StyledDiv>

      {!!helperText && <Error>{helperText}</Error>}
    </InputContainer>
  );
};

export default TextArea;
